const LEGACY_COLORS = {
  // brand
  strawberry: '#F4364C',
  lilac: '#AB63C7',
  beer: '#EFB60C',
  green: '#00C764',
  // neutrals
  white: '#FFFFFF',
  black_700: '#242424',
  black_300: '#C9C9C9',
  black_200: '#E4E4E4',
  // other colors
  kelly_dark: '#067951',
  crimson_dark: '#D73A2D',
  azure: '#00A2F2',
  azure_dark: '#0095DF',
  tangerine: '#F39C11',
  tangerine_dark: '#E09010',
};

export const LEGACY_BACKGROUND_COLORS = [
  '#333333',
  LEGACY_COLORS.tangerine_dark,
  LEGACY_COLORS.beer,
  LEGACY_COLORS.kelly_dark,
  LEGACY_COLORS.azure_dark,
  LEGACY_COLORS.lilac,
  LEGACY_COLORS.crimson_dark,
  LEGACY_COLORS.strawberry,
  LEGACY_COLORS.white,
  '#333333',
];

export const LEGACY_BUTTON_COLORS = [
  LEGACY_COLORS.green,
  LEGACY_COLORS.azure,
  LEGACY_COLORS.tangerine,
  LEGACY_COLORS.strawberry,
  LEGACY_COLORS.black_700,
];

const BORDER_COLOR = '#E0E2E8';

export const BACKGROUND_COLORS = [
  { fill: '#FFFFFF', borderFill: BORDER_COLOR },
  { fill: '#202641' },
];

export const ADVANCED_BACKGROUND_COLORS = [
  { fill: '#EAEAEA' },
  { fill: '#F18D00' },
  { fill: '#FCB600' },
  { fill: '#007D4F' },
  { fill: '#0095E1' },
  { fill: '#BC55C9' },
  { fill: '#F0192B' },
  { fill: '#FF004C' },
];

export const BUTTON_COLORS = [{ fill: '#324FBE' }, { fill: '#C3F0F7', borderFill: BORDER_COLOR }];

export const ADVANCED_BUTTON_COLORS = [
  { fill: '#00CE5C' },
  { fill: '#FF9800' },
  { fill: '#FF487F' },
];

export const FONT_COLORS = [{ fill: '#000000' }, { fill: '#FFFFFF', borderFill: BORDER_COLOR }];
